export default {
  default: "en",
  loginpage: {
    Mymeeting: 'My meeting',
    login: "LOGIN",
    logout: "LOGOUT",
    Successfully: "Successfully",
    idpassincorrect: 'Your user ID or password is incorrect',
    username: "Username",
    update: "Update",
    pleaslogin: "Please Login",
    Pleaseenter: 'Please Enter',
    usernameorpass: 'Username And Password',
    required: "Required",
    confirmedPassword: "ConfirmedPassword",
    passdonot: "Password do not match. Please retype",
    countTen: "Your must be at least 10 Numbers long.",
    countSix: "Your must be at least 6 characters long. Letters a-z, A-Z, 0-9",
    Pleasespecify: "Please Specify",
    nopass: "Incorrect Password",
    name: "Name",
    email: "Email",
    Tel: "Phone Number",
    qrcode: "QR CODE",
    Invitedby: "Invited by",
    checkspace: "Please check the space.",
    Invalidformat: "Invalid Format",
    onlyeng: "Only English Characters",
    Letters: "Your must be at least 8 characters long. Letters a-z, A-Z, 0-9, ! @ # $ % ^ & * ( ) _ + | ~ -",
    duplicate: "Register fail username duplicate.",
    password: "Password",
    coppy: "Copy",
    nameeng: "Name(English)",
    lastnameeng: "Last Name(English)",
    company: "Company Name",
    Register: "Register",
    phone: "Phone Number",
    click: "Click",
    cancel: "Cancel",
    joinin: "Join in your code",
    // oldversion: "Back to the old One Conference system",
    notuser: "You don't have a One Platform account yet",
    user: "You Have a One Platform account yet ?",
    forgotpassword: "Forgot Password",
    version: "Version",
    downloading: "Downloading...",
    additional: "Additional",
    coppylink: "Copy Successfully",
    Accept: "Accept",
    and: "AND",
    Privacy: "Privacy Policy",
    oneid: "Terms Of service",
    resendemail: "Resend Email",
    Instruction: "Instruction manual",
    Organizers: "User Manual for Meeting Organizers",
    participant: "User Manual for Meeting Participants",
    votesystem: "User Manual for Meeting Vote",
    Pleasestandby: "Please stand by",
    passcode: "Please enter only Number or English characters.",
    waiting: "Requesting to attend a meeting .....",
    waitingHost: "Please wait for the host to grant permission to attend the meeting. You will then be able to attend the meeting.",
  },
  roomsetting: {
    roomname: "Room Name",
    linkmeeting: "Link Meeting",
    infomeeting: 'Information Meeting',
    copylink: "copy Meeting Link",
    copyinfo: "copy Meeting Information",
    setting: "Setting",
    detaimeeting: "You Can Copy This Link To Invite To The Meeting.",
    passwordrooms: "Password Rooms",
    alertpass: "The password should be at least 4 characters long.",
    secretmeeting: "Secret Meeting",
    lock: "Lock The Meeting Room",
    anonymous: "Anonymous User",
    invitemail: "Invite Email",
    subject: "Subject",
    to: "To",
    typeroom: "Type Meeting",
    normalmeeting: "Normal Meeting",
    idrooms: "ID Rooms",
    videoquality: "Video Quality",
    pass: "Passcode",
    or: "or",
    timeConflict: {
      title: "Time Conflict with Other Meeting",
      message: "The meeting time you selected conflicts with another meeting. Please choose a new time."
    }
  },
  managepage: {
    rooms: "Create Meeting",
    roomsexpired: "Your account has expired.",
    backrooms: "Back To MeetingRooms",
    schedule: "Schedule Meeting",
  },
  shedulepage: {
    upcomingm: "Upcoming Meeting",
    historym: "History Meeting",
    share: "Share",
    editroom: "Edit Meeting",
    delrroms: "Remove Meeting",
    norecording: "No Video Recording",

  },
  upperpage: {
    vote: "Vote System",
    Storage: "Storage",
    setingprofile: "Seting Profile",
    csatButton: "CSAT Survey",
    csatTitle: "Share Your Feedback",
    csatPrompt: "Would you like to complete the customer satisfaction survey now?",
    csatYes: "Start Survey",
    csatLater: "Maybe Later",
    csatDoNotShow: "Don't show again for 24 hours"
  },
  activatepage: {
    activate: "ActivateCode",
    nopermission: "Your account does not have permission to create meeting rooms.",
    permission: "Please enter the code to enable permission to create a meeting room.",
    nocode: "If you don't have a code Please contact the administrator.",
    backtojoincode: "Back to join in your code"
  },
  joinpage: {
    attendmeet: "Attend Meeting",
    inputcode: "Enter Your Code or Link",
    empty: "Please enter the ID Rooms or link",

  },
  button: {
    btnok: "OK",
    btneesend: "Resend",
    btnnext: "NEXT",
    btnback: "BACK",
    btnACCEPT: "ACCEPT",
    btnSETTING: "Cookie Settings",
    btncancel: "CANCEL",
    btnreject: "REJECT",
    download: "Download",
    btncloserooms: "CLOSEMEETING",
    btnend: "End",
    btnstart: "START",
    notstartyet: "This meeting room is not started yet.",
    nottime: "This meeting room is not time for started yet.",
    openroom: "Unable Meeting",
    attendmeeting: "Attend the meeting",
    btnrecord: "Record",
    didnmeeting: "Didn't attend the meeting",
    restore: "Restore"
  },
  Homepage: {
    cookie: "We use cookies to make your experience of our websites better. By using and further navigating this website you accept this.",
    company: "Internet Thailand Public Company Limited.",
    address1: "1768 Thai Summit Tower, 10th - 20th Floor and IT Floor",
    address2: "New Petchaburi Road, Khwaeng Bang Kapi,",
    address3: "Khet Huay Khwang, Bangkok 10310,",
    necessaryCookies: "Necessary Cookies",
    performanceCookies: "Performance Cookies",
    targetingCookies: "Targeting Cookies",
    cookieSettings: "Cookie Settings",
    cookieDescription: "Manage your preferences for different types of cookies.",
    necessaryCookiesDescription: "Essential basic cookies to help the core functions of the website work, including access to various secure areas of the website. Without these cookies, the website will not function properly and will only be usable with the default settings, and cannot be disabled.",
    performanceDescription: "Analytical cookies help the website understand the usage patterns of visitors and improve the user experience by collecting data and reporting on user activity.",
    targetingDescription: "Marketing cookies are used to track the behavior of website visitors to display relevant advertisements for each user and to improve the effectiveness of advertising for publishers and third-party advertisers.",
    saveSettingsCooking: "Save settings",
  },
  message: {
    Sessiontimeout: "Session timeout, please login again",
    Unabletologin: "Unable to login invalid information",
    entercode: "Please enter the CODE in all fields.",
    codealready: "CODE has already been used.",
    administrator: "Please contact the administrator",
    incorrect: "Incorrect",
    expired: "Expired",
    closemeeting: "Please Close The Meeting Room.",
    newmeeting: "Unable to open a new meeting",
    delrooms: "Are you sure you want to delete this meeting room ?",
    del: "Deleted",
    delroomsucces: "Meeting deleted.",
    start: "Start",
    end: "End",
    time: "Time",
    day: "Day",
    Emailsent: "Sent E-mails Can be resent.",
    Selectemail: "Select the email  to resend.",
    Addemail: "Add new Email to send",
    Addyouremail: "Add your email",
    roomnotopened: "Can not room opened.",
    closmeetingandopen: "Please close the meeting before Editing the meeting.",
    resources: "Please wait preparing resources",
    readymeeting: "The Meeting is ready",
    messageshare: "Share this meeting link with those who need it.",
    canotclose: "There is a participant in the room, the meeting cannot be closed.",
    wrongcode: "Wrong Code or link entered",
    Entercodeorlink: "Enter ID Rooms or link",
    tryagain: "Please Try again",
    nomeeting: "No Meeting",
    pleasewait: "Please Wait",
    yousure: "You sure want Delete meeting recording video",
    Noreport: "No meeting report",
    meetingclosed: "This meeting room has been closed.",
    notstartedyet: "This meeting room is not started yet.",
    cameraOff: "Camera is off",
    loadingCamera: "Connecting to camera...",
    cameraBlocked: "Camera permission is blocked. Please enable it in your browser settings.",
    micSelect: "Microphone",
    camSelect: "Camera",
    checkMic: "Check Mic",
    micCheckInProgress: "Speak into your microphone. We'll stop in a few seconds.",
    micCheckComplete: "Microphone check complete.",
    micCheckFailed: "Unable to access the selected microphone.",
    micFallback: "Microphone {index}",
    camFallback: "Camera {index}"

  },
  table: {
    datetime: "Date and time",
    roomsname: "Meeting Rooms",
    statusrooms: "Meeting Status",
    reportrooms: "Meeting Report",
    settingmore: "Setting More",
    videorecording: "Video Recording",
    tablereport: "Table Report Meeting",
    No: "No.",
    Namemeet: "Name of attendee",
    timeinout: "Time in and out",
    period: "Period",
    annotation: "Annotation",
    recording: "Meeting recording report",
    list: "List",
    size: "Size",
    manage: "Manage",
    downloadrecord: "Downloadrecord",
    Allmeeting: "All meeting report",
    Numberattendance: "Number of meeting attendance"
  },
  otp: {
    otpcodefrom: "Please enter the OTP code from SMS before",
    entering: "Entering The meeting",
    Refcode: "Refcode",
    otpincomplete: "OTP code is incomplete",
    otpcomplete: "Authentication successfuly",
    resendagain: "Please resend OTP again.",
    Invalidcode: "Invalid code"
  },
  settingprofile: {
    setting: "Setting",
    profilesettings: "Profile Settings",
    Meetingsettings: "Meeting settings",
    btnprofilepick: "Save (Profile Picture)",
    btndelprofile: "Remove (Profile Picture)",
    editprofile: "EDIT PROFILE",
    messageedit: "Want to change your profile picture ?",
    messprofile: "Please select a profile picture."

  },
  settinglogo: {
    editlogo: "EDIT LOGO",
    btnlogopick: "Save (LOGO)",
    namecompany: "Company Name ",
    logoalready: "*If the logo already contains the company name, it is not necessary.",
    messelogo: "Please select a LOGO picture.",
    messageeditlogo: "Want to change your LOGO picture ?",
    Introduce: "White logos are not recommended.",
    pictruepng: "It is recommended to use an image without a background. and the image size doesn't exceed 75 KB",
    restorelogo: "Restore Logo",
    sizelogo: "Recommended image size 360 ​​pixels * 360 pixels or more"
  }
}
